import { render, staticRenderFns } from "./step-terms.vue?vue&type=template&id=f6291e0e&"
import script from "./step-terms.vue?vue&type=script&lang=js&"
export * from "./step-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports